export class TitlesLang {
    public AddressTitle: string;
    public AdminSetupTitle: string;
    public AppointmentConfirmationTitle: string;
    public AppointmentSearchTimeRangeTitle: string;
    public BookNewAppointmentConfirmationTitle: string;
    public ClinicSiteTitle: string;
    public ConfirmDeletionTitle: string;
    public DatePickerTitle: string;
    public DemographicsTitle: string;
    public EmailTitle: string;
    public ErrorTitle: string;
    public KioskFlowOptionsTitle: string;
    public LanguageTitle: string;
    public LoginPagetitle: string;
    public PatientCancelledCheckinTitle: string;
    public PhoneTitle: string;
    public PostalCodeConfirmationTitle: string;
    public PreferredPharmacyTitle: string;
    public SelectDefaultLanguageMessage: string;
    public SelectSiteTitle: string;
    public SelectMultiSiteTitle: string;
    public SettingsTitle: string;
    public UseableLanguagesTitle: string;
}


// WEBPACK FOOTER //
// ./src/resources/TitlesLang.ts